<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<script>
import { useDisplay } from 'vuetify';

export default {
    name: 'App',
    setup() {
        const display = useDisplay();
        return { display };
    },
    provide() {
        return {
            display: this.display,
        };
    },
    methods: {},
};
</script>
